import { FormattedMessage } from "react-intl";
import "./DocumentsUploadedMessage.scss";

const DocumentsUploadedMessage = () => {
  return (
    <div data-testid="documents-uploaded-message">
      <div className="documents-uploaded-message">
        <p>
          <FormattedMessage
            id="account-verification-passed-initial"
            defaultMessage={
              "We have received your identification documents. Your account verification has passed initial validation. Your documents will be reviewed by a member of our compliance team prior any withdrawals."
            }
          />
        </p>
        <p>
          <FormattedMessage
            id="verification-fail-message-3"
            defaultMessage={
              "If you have any questions in the meantime, please contact our customer support team on support@3et.com"
            }
          />
        </p>
      </div>
    </div>
  );
};

export default DocumentsUploadedMessage;
